export const makePhoneCall = (phoneNumber) => {
  if (!phoneNumber) return
  window.location.href = `tel:${phoneNumber}`
}
